import { render, staticRenderFns } from "./YsMaxFileUploader.vue?vue&type=template&id=c87095ba"
import script from "./YsMaxFileUploader.vue?vue&type=script&lang=js"
export * from "./YsMaxFileUploader.vue?vue&type=script&lang=js"
import style0 from "./YsMaxFileUploader.vue?vue&type=style&index=0&id=c87095ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports